export class PriceListProductPropertyItemPerioid {
  id: number;
  idPerioid: number;
  basePrice: number;
  finalPrice: number;
}
